const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i

function validColor(value) {
  const color = String(value || '').trim()
  return HEX_COLOR.test(color) ? color : null
}

function expandHex(color) {
  const raw = color.slice(1)
  const full =
    raw.length === 3
      ? raw
          .split('')
          .map((channel) => channel + channel)
          .join('')
      : raw
  return {
    r: parseInt(full.slice(0, 2), 16),
    g: parseInt(full.slice(2, 4), 16),
    b: parseInt(full.slice(4, 6), 16),
  }
}

/**
 * Light brand colors need dark type. White copy on a pale background
 * disappears, which is the storefront loader's only treatment.
 */
export function brandTone(color) {
  const { r, g, b } = expandHex(color)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.72 ? 'light' : 'dark'
}

function unwrapMedia(media) {
  if (!media) return null
  if (typeof media === 'string') return media
  if (media.data) {
    const data = Array.isArray(media.data) ? media.data[0] : media.data
    return unwrapMedia(data?.attributes || data)
  }
  return media
}

function absoluteUrl(url) {
  if (!url) return null
  const value = String(url).trim()
  if (!value) return null
  if (/^(data:|blob:|https?:)/i.test(value)) return value
  if (value.startsWith('//')) return `https:${value}`

  const base = String(process.env.REACT_APP_API || '')
    .trim()
    .replace(/\/api\/?$/i, '')
    .replace(/\/+$/, '')
  if (!base) return value
  return `${base}${value.startsWith('/') ? '' : '/'}${value}`
}

function mediaUrl(media) {
  const file = unwrapMedia(media)
  if (!file) return null
  if (typeof file === 'string') return absoluteUrl(file)
  return absoluteUrl(
    file.url ||
      file?.formats?.large?.url ||
      file?.formats?.medium?.url ||
      file?.formats?.small?.url ||
      file?.formats?.thumbnail?.url ||
      null
  )
}

/**
 * Branding for the admin page loader, matching the storefront tenant loader.
 * A name by itself is not enough: that paints a letter on a color the
 * organization never chose.
 */
export function resolvePageLoaderBranding(organization) {
  if (!organization) return null

  const branding = organization.branding
  if (branding?.enabled === false) return null

  const primaryColor = validColor(
    branding?.primaryColor ||
      organization.primaryColor ||
      organization.brandColor
  )
  const logoSrc =
    mediaUrl(branding?.logo) ||
    mediaUrl(organization.image) ||
    mediaUrl(organization.logo) ||
    absoluteUrl(organization.logoUrl) ||
    mediaUrl(organization.email_logo) ||
    mediaUrl(branding?.darkLogo) ||
    null
  const name = organization.name || null

  if (!primaryColor || (!logoSrc && !name)) return null

  return {
    name,
    primaryColor,
    logoSrc,
    tone: brandTone(primaryColor),
    showBlockTicketsBranding: branding?.showBlockTicketsBranding !== false,
  }
}
